export const pagesContractListEn = {
  actions: {
    export: 'Export',
    share: 'Share',
  },
  addContract: 'Add Contract',
  columns: {
    contractEndDate: 'Contract End Date',
    contractNo: 'Contract No.',
    contractParty: 'Contract Party (External)',
    contractStartDate: 'Contract Start Date',
    contractStatus: 'Contract Status',
    contractTitle: 'Contract Title',
    responsiblePerson: 'Responsible Person (Internal)',
  },
  filterPlaceholder: 'Filter contracts...',
  headers: {
    contractEndDate: 'Contract End Date',
    contractNo: 'Contract No.',
    contractStartDate: 'Contract Start Date',
    contractStatus: 'Contract Status',
    contractTitle: 'Contract Title',
  },
  pageTitle: 'Contracts',
  softwareLibraryEmpty: {
    dialogDescription:
      'Select the software to link to <strong>{{contractLabel}}</strong>.',
    dialogDescriptionContractFallback: 'this subscription contract',
    dialogTitle: 'Select software',
    importTenantTooltip: 'Please import a tenant.',
    missingAttributeError:
      'The software field was not found on this contract. Contact support if this continues.',
    readonlyAttributeError: 'The software cannot be edited for this contract.',
    setButton: 'Select software',
    toastErrorTitle: 'Could not update',
    toastSuccessDescription: 'The contract list will reflect the change.',
    toastSuccessTitle: 'Software updated',
  },
  status: {
    active: 'Active',
    cancelled: 'Cancelled',
    draft: 'Draft',
    renewalPending: 'Renewal Pending',
    terminated: 'Terminated',
  },
  tabs: {
    all: 'All',
    contractorVendor: 'Contractor & Vendor',
    employment: 'Employment',
    leaseAsset: 'Lease & Asset',
    purchase: 'Purchase',
    service: 'Service',
    software: 'Software',
    subscription: 'Subscription',
  },
};
